import { useEffect, useState } from 'react';
import '../assets/styles/component.css';
import useWindowWidth from '../interceptors/WidthChecker';
import Logo from './Logo';

const ImageSlider = ({ title, data}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const minImageWidth = 256

  const alphaSelected = 0.6
  const alphaNoSelected = 0.3

  const imagesPerRow = Math.max(Math.min(4, parseInt(useWindowWidth() / minImageWidth)), 1);

  const [isSliding, setIsSliding] = useState(false)

  const roundNumber = data.length - imagesPerRow + 1

  const [isHoveringLeft, setIsHoveringLeft] = useState(false)
  const [isHoveringRight, setIsHoveringRight] = useState(false)

  const alphaLeft = isHoveringLeft ? alphaSelected : alphaNoSelected
  const alphaRight = isHoveringRight ? alphaSelected : alphaNoSelected

  const handleNext = () => {
    if (!isSliding){
      setIsSliding(true)
      setCurrentIndex((currentIndex + 1) % roundNumber);
      setIsSliding(false)
    }    
  };

  const handlePrev = () => {
    if (!isSliding){
      setIsSliding(true)
      setCurrentIndex((currentIndex - 1 + roundNumber) % roundNumber);
      setIsSliding(false)
    } 
  };

  useEffect(() => {
    setCurrentIndex(Math.min(currentIndex, roundNumber - 1))
    // eslint-disable-next-line
  }, [imagesPerRow])

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  // eslint-disable-next-line
  }, [currentIndex, data.length]);

  return (
    <div className='clients-container'>
      <h2 className="text-3xl text-advise-color font-bold leading-tight information-title">
          {title}
      </h2>
      <div className="image-slider">
        <button type="button" className="z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
            onClick={handlePrev}
            onMouseEnter={() => {setIsHoveringLeft(true)}}
            onMouseLeave={() => {setIsHoveringLeft(false)}}>
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none"
                style={{backgroundColor: `rgb(31, 41, 55, ${alphaLeft})`}}>
                <svg className="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 1 1 5l4 4"/>
                </svg>
                <span className="sr-only">Previous</span>
            </span>
        </button>
        <div className="image-container">
          <div className='image-track' 
          style={{ transform: `translateX(${-currentIndex * parseInt(100 / imagesPerRow)}%)`}}>
            {data.map((image, index) => (
              <Logo src={image.src} index={index} imagesPerRow={imagesPerRow} name={image.name} key={index}/>
            ))}
          </div>
        </div>
        <button type="button" 
         className="z-30 flex items-center justify-center px-4 cursor-pointer group focus:outline-none"
         onClick={handleNext}
         onMouseEnter={() => {setIsHoveringRight(true)}}
         onMouseLeave={() => {setIsHoveringRight(false)}}>
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none"
                  style={{backgroundColor: `rgb(31, 41, 55, ${alphaRight})`}}>
                <svg className="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/>
                </svg>
                <span className="sr-only">Next</span>
            </span>
        </button>
      </div>
    </div>
    
  );
};

export default ImageSlider;
